import { useSelector } from 'react-redux';

export default function useCheckTypeUser(searchUserType) {
  const userType = useSelector(({ app }: any) => app?.currentUser?.type);

  return userType === searchUserType;
}
